import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { User as FirebaseUser } from "firebase/auth";
import React from 'react'

import PaperWrapper from "components/shared/PaperWrapper";
import Avatar from "components/shared/Avatar";

interface ProfileHeaderProps {
    user: FirebaseUser | null | undefined,
}

export default function ProfileHeader({ user }: ProfileHeaderProps) {
  return (
    <Container>
        <AvatarContainer>
            <Avatar size={80}/>
            <InformationContainer>
                <Typography variant="h6">{user?.email}</Typography>
                {/* <Typography variant="h6" >User Name</Typography> */}
                {/* <Typography>Occupation</Typography> */}
            </InformationContainer>
        </AvatarContainer>
        {/* <Button variant="outlined">Place Holder</Button> */}
    </Container>
  )
}

const Container = styled(PaperWrapper)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
});

const InformationContainer = styled(Box)({
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
});

const AvatarContainer = styled(Box)({
    display: "flex",
    gap: "2rem",
    alignItems: "center",
});
